import React from 'react';
import Hero from './components/Hero';
import AlinaLanding from './components/AlinaLanding';

function App() {
  return (
    <main className="bg-black text-white">
      <Hero />
      <AlinaLanding />
    </main>
  );
}

export default App;
